import React, { useState } from 'react'
import { message, notification, Modal, Button, Select } from 'antd'
import { DropdownItem } from "reactstrap"
import { bulkMergeBatches, actionOddBatchJobs } from "../../../../../services/api/3dApi"
import ActionChangeStatus from "./ActionChangeStatus"
import { getLocalData } from "../../../../../services/StorageServices"
import { parseJwt } from "../../../../../helpers/parseToken"
import { ActionForceRetry } from './ActionForceRetry'

const ActionSend = (props) => {
    const {
        selectedItems, handleSendLoading, refreshBatches, isOpen,
        showModal, closeModal, toggleSelectAll, batches, filters, isForceModal, onChangeForceModal,
        showModalUpdateSewing, onshowModalUpdateSewing, onCloseModalUpdateSewing, open, onShowModal2, onHideModal
    } = props
    const role = parseJwt(getLocalData('accessToken')).roles || []
    const isAdmin = role.some(item => item.name === "fac_admin")

    const [location, setLocation] = useState('MC')

    const _actionSendBulk = async () => {
        handleSendLoading(true)
        try {
            const payload = {
                list_batch_id: selectedItems,
                location,
            }
            const { data: response } = await bulkMergeBatches(payload)
            const { success, data, error } = response

            if (!success) {
                message.error(error)
                props.toggleSelectAll(false)
                return handleSendLoading(false)
            }

            const { successJobs, failed } = data

            notification.open({
                message: 'Xử lý file sản xuất',
                description: <div>Có <strong className="text-success">{successJobs.length}</strong> lô bắt đầu quá trình xử
                    lý file, <strong className="text-danger">{failed.length}</strong> lô đã chuyển trạng thái sản xuất.
                </div>,
                onClick: () => {
                    console.log('Notification Clicked!')
                },
            })

            handleSendLoading(false)
            refreshBatches()
            props.toggleSelectAll(false)
        } catch (e) {
            message.error(e.message)
            return handleSendLoading(false)
        }
    }

    const _actionOddBatchJobs = async () => {
        try {
            const listSelects = (Array.isArray(batches) && !!batches.length) ? batches.map(item => {
                if (selectedItems.includes(item._id)) return item.basename
            }).filter(Boolean) : []

            const payload = {
                batches: listSelects
            }

            const { data: res } = await actionOddBatchJobs(payload)
            const { success, data, error } = Object.assign({}, res)
            if (!success) {
                notification.open({
                    message: 'Ghép lô lẻ',
                    description: <div>
                        Ghép <strong className="text-success">0</strong> hợp lệ,
                        <strong className="text-danger">{listSelects.length}</strong> lô ghép không hợp lệ.
                    </div>,
                    onClick: () => {
                        console.log('Notification Clicked!')
                    },
                })

                return
            }


            const { batches: jobSuccess = [] } = { ...data }

            const jobsError = listSelects.filter(i => {
                const isJobDone = jobSuccess.includes(i)
                return !isJobDone
            }) || []

            notification.open({
                message: 'Ghép lô lẻ',
                description: <div>Ghép <strong className="text-success">{jobSuccess.length}</strong> hợp lệ, <strong className="text-danger">{jobsError.length}</strong> lô ghép không hợp lệ.
                </div>,
                onClick: () => {
                    console.log('Notification Clicked!')
                },
            })

            refreshBatches()
            props.toggleSelectAll(false)
        } catch (e) {
            message.error(e.message)
        }
    }

    const handleOk = () => {
        _actionSendBulk()
    }

    const handleChangeLocation = (value) => {
        setLocation(value)
    }

    return (
        <div>
            <DropdownItem onClick={handleOk}>Xử lý file sản xuất</DropdownItem>
            {/* <DropdownItem onClick={showModal}>Chuyển lô chờ may</DropdownItem> */}
            <DropdownItem onClick={_actionOddBatchJobs}>Ghép lô lẻ</DropdownItem>
            {filters.status === 'wait_to_sew' && (filters.partner === 'SWAT' || filters.partner === 'BU CHI TIET') &&
                <DropdownItem onClick={onshowModalUpdateSewing}>Chuyển lô Đang may</DropdownItem>
            }
            <ActionChangeStatus
                isOpen={isOpen}
                closeModal={closeModal}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            {/* <ActionChangeSewing
                isOpen={showModalUpdateSewing}
                closeModal={onCloseModalUpdateSewing}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            /> */}

            {
                isAdmin &&
                <DropdownItem onClick={() => onChangeForceModal(true)}>Force retry</DropdownItem>
            }
            <ActionForceRetry
                isOpen={isForceModal}
                closeModal={() => onChangeForceModal(false)}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                toggleSelectAll={toggleSelectAll}
                batches={batches}
            />
            <Modal
                title="Xử lý file sản xuất"
                visible={open}
                onOk={handleOk}
                onCancel={onHideModal}
                footer={[
                    <Button onClick={onHideModal}>Trở về</Button>,
                    <Button type="primary" onClick={handleOk}>Xử lý</Button>
                ]}
            >
                <label className="font-weight-bold d-block">Chọn địa điểm</label>
                <Select
                    placeholder={'Chọn địa điểm sản xuất'}
                    value={location}
                    onChange={handleChangeLocation}
                >
                    <Select.Option value={"MC"}>MC Lab</Select.Option>
                </Select>
            </Modal>
        </div>
    )
}

export default ActionSend
